export default __webpack_public_path__ + "static/media/logo.512a9124.svg";